function collectWithdrawAddressSubmissions(addressStatus, form, editingAddress, originalAddressIds = {}) {
  return Object.entries(addressStatus).reduce((addresses, [protocol, status]) => {
    const isUnbound = status === 2
    const isEditing = Boolean(editingAddress[protocol])

    if (!isUnbound && !isEditing) {
      return addresses
    }

    const address = String(form[protocol] || '').trim()
    if (address) {
      if (isEditing) {
        const id = originalAddressIds[protocol]
        if (id) {
          addresses.update[protocol] = { id, address }
        }
      } else {
        addresses.bind[protocol] = address
      }
    }

    return addresses
  }, { bind: {}, update: {} })
}

function getWithdrawAddressEditValue(originalAddresses, protocol) {
  return originalAddresses[protocol] || ''
}

module.exports = {
  collectWithdrawAddressSubmissions,
  getWithdrawAddressEditValue
}
